/** Format a shipment internal ID as "SH{n}" (e.g. SH687). */
export function shipmentId(internalId: number): string {
  return `SH${internalId}`
}

/** Format a trip internal ID as "T{n}" (e.g. T30). */
export function tripId(internalId: number): string {
  return `T${internalId}`
}

/**
 * Strip display prefixes from a user-typed search term so it can be matched
 * against the raw numeric internalId column.
 * Returns the numeric string, or the original term if no known prefix found.
 *
 * Examples:
 *   "sh687"   → "687"
 *   "SH687"   → "687"
 *   "T30"     → "30"
 *   "#1212"   → "1212"
 *   "mangrullo" → "mangrullo"  (unchanged)
 */
export function stripEntityIdPrefix(term: string): string {
  return term.trim().replace(/^#\s*/, "").replace(/^(sh|t)/i, "")
}
